module.exports = __webpack_public_path__ + "img/esthetique.212b5e74.png";